import { render, staticRenderFns } from "./MapPopupEditor.vue?vue&type=template&id=4a948001"
import script from "./MapPopupEditor.vue?vue&type=script&lang=js"
export * from "./MapPopupEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports